import React from 'react';
import PropTypes from 'prop-types';

const Card = ({
  children, header, className, data,
}) => (
  <div className={`bvs-card ${className}`} {...data}>
    { header && <div className="bvs-card__header">{ header }</div>}
    { children }
  </div>
);

Card.propTypes = {
  header: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  data: PropTypes.instanceOf(Object),
};

Card.defaultProps = {
  header: '',
  className: '',
  data: {},
};

export default Card;
